module.exports = __webpack_public_path__ + "img/activity_ico.3e1bfe33.png";